'use client';
import {memo as Memo, useMemo, useState} from 'react';
import { useRouter } from 'next/navigation';

//* HOC's
import { withDataContext, withUIContext } from '@/context';

//* Style
import BlogItemStyle from './BlogItemStyle';

//* Component's
import Page from '@/components/common/Page';
import Text from '@/components/common/Text';
import Image from '@/components/common/Image';
import Button from '@/components/common/Button';
import Preview from "@/modules/blog/components/Preview";
import CustomLink from "@/components/common/CustomLink";

function formatDate(dateString) {
	const date = new Date(dateString);
	return date.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
}

const BlogItemTemplate = Memo(({pageData, postsData, lang}) => {
	const router = useRouter();

	const [activeState, setActiveState] = useState(null)

	const posts = useMemo(() => postsData.data.filter(item => item.id !== pageData.id), [postsData]);

	return (
		<Page className={'blog'}>
			<BlogItemStyle>
				<div className="section">
					<div className="blog-header">
						<div className={'article-title'}>
							<CustomLink url={'/'} className="article-title-link">Home</CustomLink>
							/
							<CustomLink url={`/${lang}/blog/`} className="article-title-link">Blog</CustomLink>
							/ {pageData.title}
						</div>

						<Text tag={'h1'} className={'h3 font-montserrat-semibold blog-title'}>{pageData.title}</Text>
						<Text className={'sub-title'}>{formatDate(pageData.created_at)}</Text>
					</div>
				</div>
				<Image width={1156} height={521} className="blog-image" src={pageData?.image?.url} alt={pageData?.image?.alt} />

				<div className={'blog-block'}>
					{pageData.description &&
						<div className="blog-block-text">
							<div dangerouslySetInnerHTML={{__html: pageData.description}}></div>
						</div>
					}
					<div className="divider"/>
					<div className="response">
						<Text>Did this article helps you?</Text>
						<Button onClick={() => setActiveState('up')}
								className={`response-button ${activeState === 'up' ? 'response-button-active' : ''}`}>
							<div className="response-button-group">
								<Image className="response-button-icon" width={24} height={24}
									   src="/images/handUp.svg"/><Text>Yes, thanks!</Text>
							</div>
						</Button>
						<Button onClick={() => setActiveState('down')}
								className={`response-button ${activeState === 'down' ? 'response-button-active' : ''}`}>
							<div className="response-button-group">
								<Image className="response-button-icon" width={24} height={24}
									   src="/images/handDown.svg"/><Text>No, not helps</Text>
							</div>
						</Button>
					</div>
					<Text className={'h4 font-montserrat-semibold'}>Related articles</Text>
					<div className="related">
						{posts.sort((a, b) => {
                            const toNumber = (d) => {
                                const [day, month, year] = d.split('/').map(Number);
                                return year * 10000 + month * 100 + day;
                            };
                            return toNumber(b.publishing_date) - toNumber(a.publishing_date);
                        }).map((post) => (
							<div className="blog-link" key={`/${lang}/blog/${post.slug}`} onClick={() => router.push(`/${lang}/blog/${post.slug}`)}>
								<Preview post={post}/>
							</div>
						))}
					</div>
				</div>
			</BlogItemStyle>
		</Page>
	);
});

export default withUIContext(withDataContext(BlogItemTemplate, ['setPartners']), ['updatePageResize', 'updatePageResizeState']);
